<template>
  <div class="col-lg-12 padding-spinner">
    <!-- Processing... -->
    <div class="text-center">
      <div class="spinner-border text-dark" role="status" style="">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import * as CONFIG from '../../config/index'
  import {processCrowdToken} from '../../common/helper'
  import azureCommon from '../../common/azureCommon';
  export default {
    name: 'ProcessLogin',
    created(){
      this.processLogin();
    },
    methods: {
      processCrowdToken: async function () {
        let check = await processCrowdToken();
        if (check) {
          window.location.href = `${CONFIG.CLIENT_URL}/#/home`;
        }
        },

      processLogin : async function () {
        let url = `${CONFIG.CLIENT_URL}/#/process-login/?code=`
        let code = window.location.href.substring(url.length, window.location.href.length)
        let res = await azureCommon.loginAzure(code);   //login with azure    
        this.$cookies.set("username", res.username, CONFIG.COOKIES_EXPIRED_TIME);
        this.$cookies.set("accessToken", res.token, CONFIG.COOKIES_EXPIRED_TIME);
        this.$cookies.set("roles", res.roles, CONFIG.COOKIES_EXPIRED_TIME);
        this.$cookies.set("fsuBuAdmin", res.fsuBuAdmin, CONFIG.COOKIES_EXPIRED_TIME);
        this.$cookies.set("accountCustomerAdmin", res.accountCustomerAdmin, CONFIG.COOKIES_EXPIRED_TIME);
        this.$cookies.set("roleFsuBuDeptCode", res.roleFsuBuDeptCode, CONFIG.COOKIES_EXPIRED_TIME);
        this.$cookies.set("userEmail", res.userEmail, CONFIG.COOKIES_EXPIRED_TIME);
        this.$cookies.set("globalRoles", res.globalRoles, CONFIG.COOKIES_EXPIRED_TIME);
        this.$cookies.set("company", res.company, CONFIG.COOKIES_EXPIRED_TIME);
        window.localStorage.setItem('permissions', JSON.stringify(res.permissions));
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + res.token;
        window.location.href = CONFIG.CLIENT_URL + "/#/home";
      },
    },
    mounted () {
      //alert(window.location.href);
      //this.processCrowdToken();
    }
  }
</script>

<style scoped>
@media (max-width: 575.98px) {
  .padding-spinner{
    padding-top: 200px;
  }
}

@media (max-width: 767.98px) {
  .padding-spinner{
    padding-top: 150px;
  }
}

@media (max-width: 991.98px) {
  .padding-spinner{
    padding-top: 300px;
  }
}

@media (max-width: 1199.98px) {
  .padding-spinner{
    padding-top: 350px;
  }
}

@media (min-width: 992px) {
  .padding-spinner{
    padding-top: 350px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/pages/ProcessLogin.vue